import * as React from "react";
import type { SVGProps } from "react";
const SvgCalendarWithCheckMark = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M10.2 17.6c.19.25.49.4.8.4h.04a.99.99 0 0 0 .81-.47l5-8a1.003 1.003 0 0 0-1.7-1.06l-4.23 6.76L8.8 12.4c-.33-.44-.96-.53-1.4-.2s-.53.96-.2 1.4z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M17 3c.55 0 1 .45 1 1h1.99C21.1 4 22 4.9 22 6.01v12.98c0 1.11-.9 2.01-2.01 2.01H4.01C2.9 21 2 20.1 2 18.99V6.01C2 4.9 2.9 4 4.01 4H6c0-.55.45-1 1-1s1 .45 1 1h8c0-.55.45-1 1-1M6 6.01c.005.545.453.99 1 .99s.995-.445 1-.99h8c.006.545.453.99 1 .99s.994-.445 1-.99h2v12.98H4.01V6.01z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgCalendarWithCheckMark;
